import validator from 'validator';
import { isValidPhoneNumber } from 'react-phone-number-input';

const regexEmail = /@[a-zA-Z.]+$/;

export const EMAIL_MAX_LENGTH = 255;

export const isValidEmail = (text: string) => {
    return (
        validator.isEmail(text, { allow_utf8_local_part: false }) &&
        regexEmail.test(text) &&
        text.length <= EMAIL_MAX_LENGTH
    );
};

const regexEmailSymbols = /^[a-zA-Z0-9@.!#$%&'*+-/=?^_`{|}~"(),:;<>\\[\]]*$/;

export const isValidEmailSymbols = (text: string) => {
    return regexEmailSymbols.test(text);
};

export const isValidEmail4Login = (text: string) => {
    return (
        validator.isEmail(text, { allow_utf8_local_part: false }) && text.length <= EMAIL_MAX_LENGTH
    );
};

const regexPassword = /^[a-zA-Z0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]{8,128}$/;

export const PASSWORD_MAX_LENGTH = 128;

export const isValidPassword = (text: string) => {
    return (
        validator.isStrongPassword(text, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 0,
        }) && regexPassword.test(text)
    );
};

export const isValidPassword4Login = (text: string) => {
    return (
        validator.isStrongPassword(text, { minSymbols: 0 }) && text.length <= PASSWORD_MAX_LENGTH
    );
};

const regexName = /^[a-zA-Zа-яА-Я\-/(). ]{2,128}$/;

export const NAME_MAX_LENGTH = 128;

export const isValidName = (text: string) => {
    return regexName.test(text);
};

const regexNameSymbols = /^[a-zA-Zа-яА-Я\-/(). ]*$/;

export const isValidNameSymbols = (text: string) => {
    return regexNameSymbols.test(text);
};

export const isValidMiddle = (text: string | undefined) => {
    return !text || isValidName(text);
};

const regexContent = /^[a-zA-Z0-9а-яА-Я(). "<>'`,+\-_\n\r]+$/;

export const CONTENT_MAX_LENGTH = 2055;

export const isValidContent = (text: string | undefined, minL = 2, maxL = CONTENT_MAX_LENGTH) => {
    if (!text) {
        return false;
    }

    return regexContent.test(text) && text.length >= minL && text.length <= maxL;
};

const regexContentSymbols = /^[a-zA-Z0-9а-яА-Я(). "<>'`,+\-_\n\r]*$/;

export const isValidContentSymbols = (text: string) => {
    return regexContentSymbols.test(text);
};

const regexAsk = /^[?a-zA-Z0-9а-яА-Я(). "<>'`,+\-_\n\r]+$/;

export const isValidAsk = (text: string | undefined, minL = 2, maxL = CONTENT_MAX_LENGTH) => {
    if (!text) {
        return false;
    }

    return regexAsk.test(text) && text.length >= minL && text.length <= maxL;
};

const regexAskSymbols = /^[?a-zA-Z0-9а-яА-Я(). "<>'`,+\-_\n\r]*$/;

export const isValidAskSymbols = (text: string) => {
    return regexAskSymbols.test(text);
};

const regexAboutMe = /^[a-zA-Zа-яА-Я0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]+$/;

export const isValidAboutMe = (text: string | undefined, minL = 2, maxL = CONTENT_MAX_LENGTH) => {
    if (!text) {
        return false;
    }

    return regexAboutMe.test(text) && text.length >= minL && text.length <= maxL;
};

const regexAboutMeSymbols = /^[a-zA-Zа-яА-Я0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/;

export const isValidAboutMeSymbols = (text: string) => {
    return regexAboutMeSymbols.test(text);
};

const regexVkLink =
    /^(https:\/\/vk.com\/[a-zA-Z0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]{2,128})?$/;

export const isValidVkLink = (text: string | undefined) => {
    return regexVkLink.test(!!text ? text.toLowerCase() : '');
};

const regexTelegramLink =
    /^(https:\/\/t.me\/[a-zA-Z0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]{2,128})?$/;

export const isValidTelegramLink = (text: string | undefined) => {
    return regexTelegramLink.test(!!text ? text.toLowerCase() : '');
};

const regexLILink =
    /^(https:\/\/www.linkedin.com\/[a-zA-Z0-9`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]{2,128})?$/;

export const isValidLinkedInLink = (text: string | undefined) => {
    return regexLILink.test(!!text ? text.toLowerCase() : '');
};

export const isValidLinkSymbols = isValidAboutMeSymbols;

export const isValidPhone = (phone: string) => {
    return !!phone && isValidPhoneNumber(phone);
};
